import './IdentityView.scss';
import classnames from 'classnames';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import PropTypes from 'prop-types';
import React from 'react';
import {
    useIdentityView,
    withIdentityContext,
} from 'routes/formsView/IdentityVerificationViews/IdentityView/contexts/IdentityViewContext/IdentityViewContext';
import getSingleIdentificationOption from 'routes/formsView/IdentityVerificationViews/IdentityView/utils/getSingleIdentificationOption';
import ProfileStep3Container from 'components/newAccountSteps/profileSteps/ProfileStep3Container';
import { LocalStorageStorage } from 'utilities/Storage/LocalStorageStorage';
import { IdentityHeadline } from 'routes/formsView/IdentityVerificationViews/IdentityView/IdentityHeadline/IdentityHeadline';

const storage = LocalStorageStorage();

const IdentityView = ({ identificationByCountry, investmentType }) => {
    const { isSelectedVideoselfieWithBiometrics, isCarrouselActive } = useIdentityView();

    const singleIdentificationMethod = getSingleIdentificationOption({
        isCarrouselActive,
        identificationMethods: identificationByCountry(),
        isSelectedVideoselfieWithBiometrics,
    });

    const classNamesContainer = classnames('identity-verification-views basic-layering', {
        'identity-verification-views__single-option': singleIdentificationMethod,
    });

    return (
        <div className={classNamesContainer} data-testid="identity-view">
            <IdentityHeadline singleIdentificationMethod={singleIdentificationMethod} investmentType={investmentType} />
            <ProfileStep3Container storage={storage} />
            <WelcomeCard />
        </div>
    );
};

IdentityView.propTypes = {
    investmentType: PropTypes.string,
};
export default withIdentityContext(IdentityView, storage);
